import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "positiveField",
    "notesContainer",
    "notesField",
    "positiveBtn",
    "negativeBtn",
    "buttonContainer",
    "prevLink",
    "nextLink"
  ]

  static values = {
    bookingId: String
  }

  connect() {
    this.bindKeyboardShortcuts()
  }

  disconnect() {
    this.unbindKeyboardShortcuts()
  }

  bindKeyboardShortcuts() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  unbindKeyboardShortcuts() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    // Don't trigger shortcuts when typing in form fields
    if (this.isTypingInInput(event)) {
      // Allow Escape to close notes form even when focused
      if (event.key === "Escape" && this.hasNotesContainerTarget) {
        this.hideNotesForm()
        event.preventDefault()
      }
      return
    }

    switch (event.key.toLowerCase()) {
      case "y":
        event.preventDefault()
        this.submitPositive()
        break
      case "n":
        event.preventDefault()
        this.showNotesForm()
        break
      case "arrowleft":
        event.preventDefault()
        this.goToPrevious()
        break
      case "arrowright":
        event.preventDefault()
        this.goToNext()
        break
      case "escape":
        event.preventDefault()
        this.hideNotesForm()
        break
    }
  }

  isTypingInInput(event) {
    const target = event.target
    const tagName = target.tagName.toLowerCase()
    return tagName === "input" || tagName === "textarea" || tagName === "select" || target.isContentEditable
  }

  submitPositive() {
    if (!this.hasPositiveFieldTarget || !this.hasFormTarget) return

    this.positiveFieldTarget.value = "true"
    this.formTarget.requestSubmit()
  }

  showNotesForm() {
    if (!this.hasNotesContainerTarget || !this.hasPositiveFieldTarget) return

    this.positiveFieldTarget.value = "false"
    this.notesContainerTarget.classList.remove("d-none")

    // Hide the positive/negative buttons
    if (this.hasButtonContainerTarget) {
      this.buttonContainerTarget.classList.add("d-none")
    }

    // Focus the notes field
    if (this.hasNotesFieldTarget) {
      this.notesFieldTarget.focus()
    }
  }

  hideNotesForm() {
    if (!this.hasNotesContainerTarget) return

    this.notesContainerTarget.classList.add("d-none")

    if (this.hasNotesFieldTarget) {
      this.notesFieldTarget.value = ""
    }

    if (this.hasPositiveFieldTarget) {
      this.positiveFieldTarget.value = ""
    }

    // Show the positive/negative buttons again
    if (this.hasButtonContainerTarget) {
      this.buttonContainerTarget.classList.remove("d-none")
    }
  }

  goToPrevious() {
    if (this.hasPrevLinkTarget) {
      this.prevLinkTarget.click()
    }
  }

  goToNext() {
    if (this.hasNextLinkTarget) {
      this.nextLinkTarget.click()
    }
  }
}
